import { YOUSURE_CYBER_NL_FLOW_ID } from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';

const useStartYousureCyberFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (
    uuid?: string,
    inputUrl?: string,
    partyId?: string,
    quoteId?: string,
  ) => {
    reset();

    await initFlow({
      flowId: YOUSURE_CYBER_NL_FLOW_ID,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
      },
      inputUrl,
      outputUrl: `/sales-conversation/default/finalize`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartYousureCyberFlow;
